export default "__VITE_ASSET__BuoOPUmr__"